export default "<router-outlet>\n  <app-spinner></app-spinner>\n</router-outlet>\n\n<ng2-toasty position=\"bottom-right\"></ng2-toasty>\n"